import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export class SliderHotpoint {
  constructor() {
    this.initSlider();
  }

  initSlider() {
    new Swiper(".slider-hotpoint .swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".slider-hotpoint__nav--next",
        prevEl: ".slider-hotpoint__nav--prev",
      },
    });
  }
}
